import React, { useEffect, useState } from 'react';
import api from '../lib/api';
import { Trophy, Award } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';
import { useLanguage } from '../contexts/LanguageContext';

const Achievements = () => {
  const [achievements, setAchievements] = useState([]);
  const { theme } = useTheme();
  const { t, dateLocale } = useLanguage();

  useEffect(() => { fetchAchievements(); }, []);

  const fetchAchievements = async () => {
    try {
      const response = await api.get('/achievements');
      setAchievements(response.data);
    } catch (error) {
      console.error('Error fetching achievements:', error);
    }
  };

  return (
    <div data-testid="achievements-page" className="space-y-8">
      <div>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight mb-2" style={{ color: theme.accent }}>{t('achievements')}</h1>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {achievements.map((achievement) => {
          const date = new Date(achievement.earned_at);
          const formattedDate = date.toLocaleDateString(dateLocale, { year: 'numeric', month: 'long', day: 'numeric' });
          return (
            <div key={achievement.id} data-testid={`achievement-${achievement.id}`}
              className="p-6 rounded-lg hover:-translate-y-1 transition-all duration-300"
              style={{ background: theme.card, border: `1px solid ${theme.border}` }}>
              <div className="flex items-start gap-4">
                <div className="p-3 rounded-lg" style={{ background: `${theme.primary}20`, border: `1px solid ${theme.border}` }}>
                  <Trophy size={32} style={{ color: theme.accent }} />
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-medium tracking-tight mb-2" style={{ color: theme.accent }}>{achievement.title}</h3>
                  <p className="text-sm mb-3" style={{ color: theme.textSecondary }}>{achievement.description}</p>
                  <p className="text-xs font-medium" style={{ color: theme.primary }}>{formattedDate}</p>
                </div>
              </div>
            </div>
          );
        })}
        {achievements.length === 0 && (
          <div className="col-span-full text-center py-20">
            <Award size={48} className="mx-auto mb-4" style={{ color: theme.textMuted }} />
            <p className="text-lg" style={{ color: theme.textSecondary }}>Aún no has desbloqueado logros</p>
            <p className="text-sm mt-2" style={{ color: theme.textMuted }}>Completa metas para ganar certificados</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Achievements;
